import { observable, action, runInAction, computed, toJS } from 'mobx';
import React from 'react';
import { Link } from 'react-router-dom';
import { Layout, Menu, Icon } from 'antd';
import { observer } from 'mobx-react';

import * as NavConfig from '@common/NavConfig.js';
import login_user_store from '@src/Store/LoginUser/LoginUserStore';
import user_store, { pagination_store, filter_store, ItemStore } from '@store/User/UserList/UserStore';
import wallet_store, {WalletItemStore} from '@store/Statistic/WalletHistory/WalletHistoryStore';

import { navigation_style } from '@src/env-config';

const SubMenu = Menu.SubMenu;
const MenuItem = Menu.Item;

const { Sider, Header } = Layout;

class SidebarStore {
  @observable
  path_array = [];

  constructor() {
    this.setPathArray();
  }

  @action
  setPathArray() {
    let path = window.location.pathname;
    let temp_path_array = path.split('/');
    // 去除第一个空元素
    temp_path_array.shift();
    this.path_array = this.generateLink( temp_path_array );

  }

  /**
   * 获取导航栏默认打开的 Submenu
   */
  @computed
  get open_keys() {
    let path = this.path_array.slice(-1)[0];
    let result = [];
    if(NavConfig.getNavNodeByMatchPath( path )) {
      result = [ NavConfig.getNavNodeByMatchPath( path ).parent.path ];
    }
    return result;
  }

  /**
   * 获取导航栏默认选中的 Link
   */
  @computed
  get selected_keys() {
    let result = this.path_array.slice(-1);
    return result;
  }

  generateLink(path_array) {
    let result = []
    for(let i = 0; i < path_array.length; i++ ) {
      let temp_path = (result[i - 1] || '') + '/' +  path_array[i];
      if(NavConfig.getNavNodeByMatchPath(temp_path)) {
        result.push(temp_path);
      }
    }
    return result;
  }
}

let sidebar_store = new SidebarStore();

@observer
class Sidebar extends React.Component {
  constructor() {
    super();
    this.state = { collapsed: false };
  }

  getMenuItemLink = (menu) => {
    if ( menu.is_Nav ) {
      let path = NavConfig.getNavNodeByName(menu.name).path;
      if (path.indexOf(':id') != -1)
      {
        path = path.replace(':type',ItemStore.Type_Normal);
        path = path.replace(':id',login_user_store.id);
        path = path.replace(':username',login_user_store.pet_name);
      }
      return (
        <Link to={path}>
          {menu.name}
        </Link>
      )
    } else {
      return null
    }
  }

  /**
   * 根据导航配置的条目，生成导航配置条目
   * 判断配置条目是否还有子级，
   * * 有，生成 SubMenu标签，并进行递归生成子级标签；
   * * 无，生成导航 Link
   */
  getSubMenuOrItem = (menu) => {
    // if ( !menu.role_array.includes('user-setting') ) {  // 所有用户都可以访问设置界面
    //   if( !login_user_store.is_super_admin ) {  // 非超级管理员身份，需要判断应该 显示有权限访问的菜单
    //     // 已登录用户的权限列表
    //     let login_user_role_array = toJS( login_user_store.role_array );
    //     // 可以访问当前页面的权限列表
    //     let menu_role_array = menu.role_array;
    //     let show_menu = false;
    //     /**
    //      * 遍历判断 用户当前的权限 是否 用户导航配置需要的权限
    //      */
    //     for( let i = 0; i < menu_role_array.length; i++ ) {
    //       if( login_user_role_array.includes( menu_role_array[i] ) ) {
    //         show_menu = true;
    //         break;
    //       }
    //     }

    //     if( !show_menu ) {
    //       return;
    //     }
    //   }
    // }

    if(menu.children && Array.isArray(menu.children)) {
      return (
        <SubMenu
          key={menu.path} title={
          <span>
            <Icon type={`${menu.icon}`} />
            <span>
              {`${menu.name}`}
            </span>
          </span>
        }>
          {
            menu.children.map((item, index) => {
              return this.getSubMenuOrItem(item);
            })
          }
        </SubMenu>
      )
    } else {
      if( menu.is_Nav ) {
        // console.warn("is_nav: ", menu);
        return (
          <MenuItem key={menu.path}>
            {
              this.getMenuItemLink(menu)
            }
          </MenuItem>
        )
      }
    }
  }

  /**
   * 遍历导航配置生成侧边栏导航
   */
  getNavMenuItems = (menus) => {
    return menus.map((menu, index) => {
      return this.getSubMenuOrItem(menu);
    })
  }

  onCollapse = (collapsed) => {
    this.setState({
      collapsed
    })
  }

  render() {
    if (navigation_style === 0)
    {
      return (
        <Sider
          style={{
            boxShadow: '2px 0 6px rgba(0, 21, 41, .35)'
          }}
          width={ 210 }
          breakpoint='lg'
          collapsible={ true }
          collapsed={ this.state.collapsed }
          onCollapse={ this.onCollapse }>
          <div style={{
            height: '64px',
            background: '#114abc'
          }}>
            <img src={require('../../assets/logo2.png')} alt=""/>
          </div>
          <Menu
            mode='inline'
            theme='dark'
            defaultOpenKeys={ sidebar_store.open_keys }
            defaultSelectedKeys={ sidebar_store.selected_keys }
            // inlineCollapsed={false}
            inlineIndent={24}>
            {
              this.getNavMenuItems( NavConfig.nav_data[0].children )
            }
          </Menu>
        </Sider>
      )
    }
    return (
      <Header
        style={{
          boxShadow: '2px 0 6px rgba(0, 21, 41, .35)',
          padding: '0px',
          display: 'flex',
        }}
        breakpoint='lg'
        collapsible={ true }
        collapsed={ this.state.collapsed }
        onCollapse={ this.onCollapse }>
        <div style={{
          width: '210px',
          height: '64px',
          background: '#114abc'
        }}>
          <img src={require('../../assets/logo2.png')} alt=""/>
        </div>
        <Menu
          mode='horizontal'
          theme='dark'
          defaultSelectedKeys={ sidebar_store.selected_keys }
          inlineCollapsed={false}
          inlineIndent={24}>
          {
            this.getNavMenuItems( NavConfig.nav_data[0].children )
          }
        </Menu>
      </Header>
    )
  }

  componentDidMount() {
    this.setState({ someKey: 'otherValue' });
  }
}

export { sidebar_store };
export default Sidebar;



// WEBPACK FOOTER //
// ./src/components/Sidebar/Sidebar.jsx